import { useState, useEffect } from "react";
import { Form, Button, Alert, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faTrash } from "@fortawesome/free-solid-svg-icons";
import {useAuth} from "../../providers/authprovider";

function AddNoteForm(props) {
    const eventId = props.eventId;
    const { calendar: { saveEventNote } } = useAuth();
    const [disabled, setDisabled] = useState(false);
    const [note, setNote] = useState({ value: "", event_id: eventId });
    const [alert, setAlert] = useState({ show: false, content: "" });
    const [images, setImages] = useState([]);

    const hideAlert = () => setAlert({ show: false, content: "" });
    const addAlert = (content) => setAlert({ show: true, content: content });

    useEffect(() => {
        if (props.note === undefined)
            setNote({ value: "", event_id: eventId });
        else
            setNote(props.note);
    }, [props.note]);

    const handleSetNote = (event) => {
        setNote({ ...note, value: event.target.value });
    };

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        const validFiles = files.filter(file => {
            return file.type.startsWith("image/") && file.size <= 10 * 1024 * 1024;
        });

        if (validFiles.length < files.length) {
            addAlert("Niektóre pliki zostały pominięte (muszą być obrazkami i mieć < 10MB)");
        }

        setImages(prev => [...prev, ...validFiles]);
        event.target.value = null; // reset file input
    };

    const handleRemoveImage = (index) => {
        setImages(prev => prev.filter((_, i) => i !== index));
    };

    const handleSave = () => {
        if (note.value.trim().length <= 0)
            return addAlert("Wprowadź treść notatki");

        hideAlert();
        setDisabled(true);

        const formData = new FormData();
        formData.append("value", note.value);
        formData.append("event_id", note.event_id);

        images.forEach((file, idx) => {
            formData.append(`images`, file);
        });

        saveEventNote(formData, (response) => {
            setDisabled(false);

            if (response.success) {
                setNote({ ...note, value: "" });
                setImages([]);
                return props.onSave(response.content);
            }

            addAlert(response.error);
        });
    };

    return (
        <div>
            <h6>Notatki do zlecenia</h6>
            <Form.Group className="p-3" controlId="note">
                <Alert show={alert.show} variant={"warning"} onClose={hideAlert} dismissible>
                    <p>{alert.content}</p>
                </Alert>

                <Form.Control
                    value={note.value}
                    onChange={handleSetNote}
                    type="text"
                    as={"textarea"}
                    rows={5}
                    placeholder="wprowadź treść notatki"
                />

                <Form.Control
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={handleFileChange}
                    className="my-3"
                />

                {images.length > 0 && (
                    <div style={{ display: "flex", overflowX: "auto", gap: "10px" }}>
                        {images.map((file, index) => (
                            <div key={index} style={{ position: "relative", display: "inline-block" }}>
                                <Image
                                    src={URL.createObjectURL(file)}
                                    thumbnail
                                    style={{ width: "100px", height: "100px", objectFit: "cover" }}
                                />
                                <Button
                                    variant="danger"
                                    size="sm"
                                    style={{
                                        position: "absolute",
                                        top: "0",
                                        right: "0",
                                        borderRadius: "50%",
                                        padding: "2px 6px",
                                    }}
                                    onClick={() => handleRemoveImage(index)}
                                >
                                    <FontAwesomeIcon icon={faTrash} />
                                </Button>
                            </div>
                        ))}
                    </div>
                )}

                <div className="p-2">
                    {disabled ? (
                        <Button variant="primary"><FontAwesomeIcon icon={faSpinner} spin /></Button>
                    ) : (
                        <Button variant="primary" onClick={handleSave}>Zapisz</Button>
                    )}
                </div>
            </Form.Group>
        </div>
    );
}

export default AddNoteForm;
